export default __webpack_public_path__ + "static/media/illustration-editor-mobile.b9c7941a.svg";